import { gql } from '@apollo/client';
import { Checkbox } from '@blueprintjs/core';
import TableCell from '../../../components/TableCell';
import Text from '../../../components/Text';
import { LocationListItemFragment } from '../../../generated/graphql';
import { noop } from '../../../helpers/utils';
import { useNavigateSafely } from '../../../hooks/useNavigateSafely';
import { ListItemComponent } from '../../../types';

export type LocationListProps = {
  item: LocationListItemFragment;
  skeleton?: boolean;
} & ListItemComponent;

const LocationListItem = ({ item, skeleton, selected, onToggle }: LocationListProps) => {
  const buildNavigateSafely = useNavigateSafely();
  const address: string | null =
    item.street && item.postal_code && item.city ? `${item.street}, ${item.postal_code} ${item.city}` : null;

  return (
    <tr onClick={onToggle || skeleton ? noop : buildNavigateSafely(`/locations/${item!.id}`)}>
      {onToggle && (
        <TableCell>
          <Checkbox inline disabled={skeleton} checked={selected} onChange={() => onToggle(item.id)} className="m-0" />
        </TableCell>
      )}
      <TableCell>
        <Text skeleton={skeleton}>{item.name}</Text>
      </TableCell>
      <TableCell>
        <Text skeleton={skeleton}>{address}</Text>
      </TableCell>
      <TableCell>
        <Text skeleton={skeleton}>{item.meeting_point}</Text>
      </TableCell>
    </tr>
  );
};

LocationListItem.fragments = {
  location: gql`
    fragment LocationListItem on Location {
      id
      name
      street
      city
      postal_code
      meeting_point
      public_transport
      accessible
    }
  `,
};

export default LocationListItem;
